export default {
  namespaced: true,
  state: {
    tableLoading: false,
    filterParams: {},
    showDataTable: false,
    filterStatusKeys: [6, 5, 9, 3, 15, 12, 11],
    defaultStatusKeys: [6],
  },
  mutations: {
    updateTableLoading(state, payload) {
      state.tableLoading = payload;
    },
    updateFilterParams(state, payload) {
      state.filterParams = payload;
    },
    updateShowDataTable(state, payload) {
      state.showDataTable = payload;
    },
  },
};
